import { useEffect } from 'react';
import { useAuthStore } from '../stores/authStore';
import { setDiagnosticOwner, stopBrowserDiagnostics } from '../lib/infra/browserDiagnostics';

export function useBrowserDiagnostics() {
  useEffect(() => {
    const sync = (s: ReturnType<typeof useAuthStore.getState>) => {
      if (s.status === 'unauthenticated') setDiagnosticOwner(null);
      else if (s.user?.id) setDiagnosticOwner(s.user.id);
    };
    sync(useAuthStore.getState());
    const unsubscribe = useAuthStore.subscribe(sync);
    return () => { unsubscribe(); stopBrowserDiagnostics(); };
  }, []);
}
